import { AtlassianProductHostingTypeValues as HostingType, MarketplaceBillingCycleValues as BillingCycle } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
export const MAX_INITIAL_TIERS_TO_DISPLAY = 5;
export const BILLING_CYCLE_FOR_HOSTING = {
  [HostingType.Cloud]: BillingCycle.Monthly,
  [HostingType.Server]: BillingCycle.Annual,
  [HostingType.DataCenter]: BillingCycle.Annual
};
export const DEFAULT_ERROR_MESSAGE_PRICING_FAILED = "Sorry, we couldn't load pricing details right now. Please try again later.";
export const VIEW_ADDITIONAL_PRICING_EXAMPLES = 'View additional pricing examples';
export const VIEW_ADDITIONAL_PRICING_DETAILS = 'View additional pricing details';
export const VIEW_DIFFERENT_TIERS_PRICING = 'View pricing for different user tiers';